import { AutogenModelOrderOtherChargeRec, AutogenRowOrderOtherChargeRec } from "./autogen/AutogenModelOrderOtherChargeRec";

export class ModelOrderOtherChargeRec extends AutogenModelOrderOtherChargeRec<RowOrderOtherChargeRec> {
    constructor() {
        super(RowOrderOtherChargeRec);
    }
}

export class RowOrderOtherChargeRec extends AutogenRowOrderOtherChargeRec {
}